import { Link, useLocation } from "react-router-dom";

type Props = {
  title?: string;
  description?: string;
};

export default function LoginRequired({
  title = "برای مشاهده این بخش وارد شوید",
  description = "پس از ورود، اطلاعات شخصی شما در این بخش نمایش داده می‌شود.",
}: Props) {
  // Carry the current page along so login can return here afterwards.
  const location = useLocation();
  const redirect = encodeURIComponent(location.pathname + location.search);

  return (
    <div className="w-full flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <p className="text-sm font-semibold text-default-800">{title}</p>
      <p className="text-xs text-default-500 leading-6">{description}</p>
      <Link
        to={`/login?redirect=${redirect}`}
        className="mt-2 h-11 px-8 rounded-xl bg-primary text-white text-sm font-bold flex items-center justify-center"
      >
        ورود به حساب
      </Link>
    </div>
  );
}
